import React, { useEffect, useState } from 'react';
import Header from '../../Layouts/Header';
import Footer from '../../Layouts/Footer';
import Breadcrumb from '../../Layouts/Breadcrumb';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { Grid } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import swal from "sweetalert";
import AuthApi from "../../Services/Authapi";
import TextField from '@material-ui/core/TextField';
import AuthCheckComponent from '../../Layouts/Token';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import EmailEditor from 'react-email-editor';
import { createSwalLoaderNode } from '../../Layouts/swalLoader';
import { useTheme } from '../../../ThemeContext';
import {
    EMAIL_EDITOR_MIN_HEIGHT,
    getEmailEditorAppearance,
    getEmailEditorCustomCss,
    getEmailEditorFrameStyle,
    getEmailEditorSurfaceStyles,
    prepareDefaultButtonDesign,
    prepareEmailDesignForEditor,
} from './emailTemplateEditorTheme';
import '../Leaves/Leave.css';

const initialTemplate = {
    title: '',
    texteditor: '',
    template_design: '',
    templates: [],
};

const fontConfig = {
    fonts: {
        showDefaultFonts: true,
        customFonts: [
            { label: 'Arial', value: 'Arial, sans-serif' },
            { label: 'Georgia', value: 'Georgia, serif' },
            { label: 'Times New Roman', value: 'Times New Roman, serif' },
            { label: 'Verdana', value: 'Verdana, sans-serif' },
            { label: 'Courier New', value: '"Courier New", monospace' },
            { label: 'Tahoma', value: 'Tahoma, sans-serif' },
            { label: 'Trebuchet MS', value: '"Trebuchet MS", sans-serif' },
            { label: 'Lucida Sans', value: '"Lucida Sans", sans-serif' },
            { label: 'Roboto', value: 'Roboto, sans-serif' },
            { label: 'Open Sans', value: '"Open Sans", sans-serif' },
            { label: 'Lato', value: 'Lato, sans-serif' },
            { label: 'Montserrat', value: 'Montserrat, sans-serif' },
            { label: 'Oswald', value: 'Oswald, sans-serif' },
            { label: 'Raleway', value: 'Raleway, sans-serif' },
            { label: 'Merriweather', value: 'Merriweather, serif' },
            { label: 'Ubuntu', value: 'Ubuntu, sans-serif' },
            { label: 'Playfair Display', value: 'Playfair Display, serif' },
            { label: 'Poppins', value: 'Poppins, sans-serif' },
            { label: 'Quicksand', value: 'Quicksand, sans-serif' },
            { label: 'Roboto Slab', value: 'Roboto Slab, serif' },
            { label: 'Source Sans Pro', value: 'Source Sans Pro, sans-serif' },
            { label: 'Varela Round', value: 'Varela Round, sans-serif' },
            { label: 'Work Sans', value: 'Work Sans, sans-serif' },
            { label: 'Dancing Script', value: '"Dancing Script", cursive' },
            { label: 'Pacifico', value: '"Pacifico", cursive' },
            { label: 'Great Vibes', value: '"Great Vibes", cursive' },
            { label: 'Lobster', value: '"Lobster", cursive' },
            { label: 'Bebas Neue', value: '"Bebas Neue", cursive' },
            { label: 'Cinzel', value: 'Cinzel, serif' },
            { label: 'Abril Fatface', value: '"Abril Fatface", cursive' },
            { label: 'Amatic SC', value: '"Amatic SC", cursive' },
            { label: 'Josefin Sans', value: '"Josefin Sans", sans-serif' },
            { label: 'Playfair Display SC', value: '"Playfair Display SC", serif' },
        ],
    },
};

const Edittemplate = (props) => {
    const classes = props;
    const { darkMode } = useTheme();
    const [doc, setDoc] = useState(initialTemplate);
    const [formErrors, setFormErrors] = useState({});
    const [isEditorReady, setIsEditorReady] = useState(false);
    const emailEditorRef = React.useRef(null);
    const isApplyingDefaultButtonStyleRef = React.useRef(false);
    const editorScopeClassName = 'template-editor-edit';
    const editorThemeKey = darkMode ? 'dark' : 'light';

    useEffect(() => {
        if (props && props.authToken === false) {
            // props.history.push('/login');
        }
    }, [props]);

    useEffect(() => {
        getEventData();
    }, []);

    useEffect(() => {
        setIsEditorReady(false);
    }, [darkMode]);

    useEffect(() => {
        if (!isEditorReady || !doc.template_design || !emailEditorRef.current?.editor) {
            return;
        }

        loadTemplateDesign();
    }, [doc.template_design, isEditorReady]);

    const loadTemplateDesign = () => {
        if (!doc.template_design || !emailEditorRef.current?.editor) {
            return;
        }

        try {
            const design = prepareEmailDesignForEditor(doc.template_design, darkMode);
            if (design) {
                emailEditorRef.current.editor.loadDesign(design);
            }
        } catch (error) {
            console.error('Error loading template design:', error);
        }
    };

    const getEventData = async () => {
        const id = props.history.location.pathname.split('/').pop();
        const upcomingEvent = await AuthApi.Templategeedit(id);
        const templateData = upcomingEvent?.status === true ? upcomingEvent.data : null;

        setDoc({
            title: templateData?.template_name || '',
            texteditor: templateData?.letters || '',
            template_design: templateData?.template_design || '',
            templates: Array.isArray(templateData?.templates) ? templateData.templates : [],
            event_Id: id,
        });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setDoc((prev) => ({ ...prev, [name]: value }));
        setFormErrors((prev) => {
            if (!prev[name]) {
                return prev;
            }

            const nextErrors = { ...prev };
            delete nextErrors[name];
            return nextErrors;
        });
    };

    const validate = (values) => {
        const errors = {};
        const regex = /^[a-zA-Z]/;

        if (!values.title) {
            errors.title = "Cannot be blank";
        } else if (!regex.test(values.title)) {
            errors.title = "Invalid title format";
        }

        values.templates.forEach((template, index) => {
            if (!template.label) {
                errors[`templateLabel${index}`] = "Template label cannot be blank";
            }
            if (!template.type) {
                errors[`templateType${index}`] = "Template type cannot be blank";
            }
        });

        return errors;
    };

    const showValidationPopup = (errors) => {
        const fieldNames = [];

        if (errors.title) {
            fieldNames.push('Title');
        }

        Object.keys(errors).forEach((key) => {
            if (key.startsWith('templateLabel')) {
                fieldNames.push('Template Label');
            }
            if (key.startsWith('templateType')) {
                fieldNames.push('Template Type');
            }
        });

        if (fieldNames.length === 0) {
            return;
        }

        swal({
            title: 'Required Fields',
            text: `Please fill: ${[...new Set(fieldNames)].join(', ')}`,
            icon: 'warning',
            button: 'OK',
        });
    };

    const exportTemplateData = () => new Promise((resolve) => {
        emailEditorRef.current.editor.exportHtml((data) => {
            const { design, html } = data;
            resolve({
                ...doc,
                texteditor: html,
                template_design: JSON.stringify(design),
            });
        });
    });

    const handleSubmit = async (e) => {
        e.preventDefault();

        const updatedDoc = emailEditorRef.current?.editor
            ? await exportTemplateData()
            : doc;

        setDoc(updatedDoc);
        const errors = validate(updatedDoc);
        setFormErrors(errors);

        if (Object.keys(errors).length > 0) {
            showValidationPopup(errors);
            return;
        }

        editUser(updatedDoc);
    };

    const editUser = async (updatedDoc) => {
        swal({
            title: "Loading",
            text: "Please wait...",
            buttons: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
            width: "10%",
            content: createSwalLoaderNode(),
        });

        try {
            const status = await AuthApi.Templateupdate(updatedDoc, updatedDoc.event_Id);
            swal.close();

            if (status && status.status === true) {
                swal("Success", "Template updated successfully", "success").then(() => {
                    props.history.push("/templates");
                });
            } else {
                swal({
                    title: "OOPS!",
                    icon: "error",
                    text: status && status.message ? status.message : "Something went wrong, Please try later!",
                });
            }
        } catch (error) {
            swal.close();
            console.error("Error updating template:", error);
            swal("Error", "An unexpected error occurred", "error");
        }
    };

    const addTemplateField = () => {
        setDoc((prev) => ({
            ...prev,
            templates: [...prev.templates, { label: '', type: '', options: [] }],
        }));
    };

    const removeTemplateField = (index) => {
        setDoc((prev) => ({
            ...prev,
            templates: prev.templates.filter((_, i) => i !== index),
        }));
    };

    const updateTemplateAtIndex = (index, updater) => {
        setDoc((prev) => {
            const newTemplates = [...prev.templates];
            newTemplates[index] = updater(newTemplates[index]);
            return { ...prev, templates: newTemplates };
        });
    };

    const handleEditorReady = (editor) => {
        editor.addEventListener('design:updated', () => {
            if (isApplyingDefaultButtonStyleRef.current) {
                isApplyingDefaultButtonStyleRef.current = false;
                return;
            }

            editor.saveDesign((design) => {
                const normalizedDesign = prepareDefaultButtonDesign(design);
                if (!normalizedDesign) {
                    return;
                }

                isApplyingDefaultButtonStyleRef.current = true;
                editor.loadDesign(normalizedDesign);
            });
        });

        loadTemplateDesign();
        setIsEditorReady(true);
    };

    return (
        <div>
            <AuthCheckComponent authToken={props.authToken} />
            <style>{getEmailEditorSurfaceStyles(darkMode, editorScopeClassName)}</style>
            <Header
                {...props}
                authUser={props.authUser}
                component={
                    <div>
                        <div className="holiday-breadcrumb-card">
                            <Breadcrumb
                                {...props}
                                primaryPageName="User Template"
                                primaryPageLink="/templates"
                                isSecondaryPage={true}
                                secondaryPageName="Edit Template"
                            />
                        </div>
                        <Grid container className={classes.root} spacing={2}>
                            <Grid item xs={12}>
                                <div className="holiday-form-card">
                                        <Typography variant="h2" className="holiday-form-title" style={{ color: '#036dda', fontSize: '24px', fontWeight: 'bold', marginBottom: '20px' }}>
                                            Generate Template
                                        </Typography>
                                        <form className={`${classes.form} common-form-fields`} onSubmit={handleSubmit}>
                                            <Grid container className={classes.root} spacing={5}>
                                                <Grid item xs={12}>
                                                    <TextField
                                                        fullWidth
                                                        id="outlined-basic"
                                                        label="Title"
                                                        name="title"
                                                        variant="outlined"
                                                        error={Boolean(formErrors.title)}
                                                        value={doc.title}
                                                        onChange={handleChange}
                                                        className={formErrors.title ? "input-error" : ""}
                                                    />
                                                    {formErrors.title && <span className="error">{formErrors.title}</span>}
                                                </Grid>
                                            </Grid>

                                            <Grid container className={classes.root} spacing={5}>
                                                <Grid item xs={12}>
                                                    <div style={{ ...getEmailEditorFrameStyle(darkMode), position: 'relative' }}>
                                                        {!isEditorReady && (
                                                            <div
                                                                style={{
                                                                    position: 'absolute',
                                                                    inset: 0,
                                                                    zIndex: 2,
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    background: darkMode ? '#161616' : '#ffffff',
                                                                    color: darkMode ? '#f8fafc' : '#64748b',
                                                                    fontSize: '15px',
                                                                    fontWeight: 500,
                                                                }}
                                                            >
                                                                Loading editor...
                                                            </div>
                                                        )}
                                                        <div className={editorScopeClassName}>
                                                            <EmailEditor
                                                                key={editorThemeKey}
                                                                ref={emailEditorRef}
                                                                onReady={handleEditorReady}
                                                                options={{
                                                                    ...fontConfig,
                                                                    appearance: getEmailEditorAppearance(darkMode),
                                                                    customCSS: getEmailEditorCustomCss(darkMode),
                                                                }}
                                                                style={{ minHeight: `${EMAIL_EDITOR_MIN_HEIGHT}px` }}
                                                            />
                                                        </div>
                                                    </div>
                                                </Grid>
                                            </Grid>

                                            {/* Add input field section kept for future use.
                                            {doc.templates.map((template, index) => (
                                                <Grid container spacing={5} key={index}>
                                                    <Grid item xs={5}>
                                                        <TextField
                                                            fullWidth
                                                            id={`outlined-template-label-${index}`}
                                                            label="Template Label"
                                                            name={`templateLabel${index}`}
                                                            variant="outlined"
                                                            error={Boolean(formErrors[`templateLabel${index}`])}
                                                            value={template.label}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                updateTemplateAtIndex(index, (current) => ({ ...current, label: value }));
                                                            }}
                                                            className={formErrors[`templateLabel${index}`] ? "input-error" : ""}
                                                        />
                                                        {formErrors[`templateLabel${index}`] && (
                                                            <span className="error">{formErrors[`templateLabel${index}`]}</span>
                                                        )}
                                                    </Grid>
                                                    <Grid item xs={5}>
                                                        <FormControl fullWidth error={Boolean(formErrors[`templateType${index}`])}>
                                                            <InputLabel id={`template-type-label-${index}`}>Template Type</InputLabel>
                                                            <Select
                                                                labelId={`template-type-label-${index}`}
                                                                id={`outlined-template-type-${index}`}
                                                                name={`templateType${index}`}
                                                                label="Template Type"
                                                                value={template.type}
                                                                onChange={(e) => {
                                                                    const value = e.target.value;
                                                                    updateTemplateAtIndex(index, (current) => ({
                                                                        ...current,
                                                                        type: value,
                                                                        options: ['radio', 'checkbox'].includes(value) ? (current.options || []) : [],
                                                                    }));
                                                                }}
                                                                className={formErrors[`templateType${index}`] ? "input-error" : ""}
                                                            >
                                                                <MenuItem value="text">Text</MenuItem>
                                                                <MenuItem value="date">Date</MenuItem>
                                                                <MenuItem value="email">Email</MenuItem>
                                                                <MenuItem value="month">Month</MenuItem>
                                                                <MenuItem value="number">Number</MenuItem>
                                                                <MenuItem value="textarea">Textarea</MenuItem>
                                                                <MenuItem value="password">Password</MenuItem>
                                                                <MenuItem value="time">Time</MenuItem>
                                                                <MenuItem value="color">Color</MenuItem>
                                                                <MenuItem value="hidden">Hidden</MenuItem>
                                                                <MenuItem value="submit">Submit</MenuItem>
                                                                <MenuItem value="radio">Radio</MenuItem>
                                                                <MenuItem value="checkbox">Checkbox</MenuItem>
                                                                <MenuItem value="file">Image</MenuItem>
                                                            </Select>
                                                            {formErrors[`templateType${index}`] && (
                                                                <span className="error">{formErrors[`templateType${index}`]}</span>
                                                            )}
                                                        </FormControl>
                                                    </Grid>
                                                    {template.type === 'radio' && (
                                                        <Grid item xs={10}>
                                                            {(template.options || []).map((option, optIndex) => (
                                                                <Grid container spacing={2} key={optIndex}>
                                                                    <Grid item xs={8}>
                                                                        <TextField
                                                                            fullWidth
                                                                            id={`outlined-radio-option-${index}-${optIndex}`}
                                                                            label={`Option ${optIndex + 1}`}
                                                                            value={option}
                                                                            onChange={(e) => {
                                                                                const value = e.target.value;
                                                                                updateTemplateAtIndex(index, (current) => {
                                                                                    const nextOptions = [...(current.options || [])];
                                                                                    nextOptions[optIndex] = value;
                                                                                    return { ...current, options: nextOptions };
                                                                                });
                                                                            }}
                                                                        />
                                                                    </Grid>
                                                                    <Grid item xs={2}>
                                                                        <Button
                                                                            onClick={() => {
                                                                                updateTemplateAtIndex(index, (current) => ({
                                                                                    ...current,
                                                                                    options: (current.options || []).filter((_, optionIndex) => optionIndex !== optIndex),
                                                                                }));
                                                                            }}
                                                                            variant="contained"
                                                                            style={{
                                                                                color: "#fff",
                                                                                backgroundColor: "#d12c2c",
                                                                                marginTop: "10px",
                                                                                textTransform: 'capitalize',
                                                                            }}
                                                                        >
                                                                            Remove
                                                                        </Button>
                                                                    </Grid>
                                                                </Grid>
                                                            ))}
                                                            <Button
                                                                onClick={() => {
                                                                    updateTemplateAtIndex(index, (current) => ({
                                                                        ...current,
                                                                        options: [...(current.options || []), ''],
                                                                    }));
                                                                }}
                                                                variant="contained"
                                                                color="primary"
                                                                style={{ marginTop: "10px", textTransform: 'capitalize' }}
                                                            >
                                                                Add Option
                                                            </Button>
                                                        </Grid>
                                                    )}
                                                    {template.type === 'checkbox' && (
                                                        <Grid item xs={10}>
                                                            {(template.options || []).map((option, optIndex) => (
                                                                <Grid container spacing={2} key={optIndex}>
                                                                    <Grid item xs={8}>
                                                                        <TextField
                                                                            fullWidth
                                                                            id={`outlined-checkbox-option-${index}-${optIndex}`}
                                                                            label={`Option ${optIndex + 1}`}
                                                                            value={option}
                                                                            onChange={(e) => {
                                                                                const value = e.target.value;
                                                                                updateTemplateAtIndex(index, (current) => {
                                                                                    const nextOptions = [...(current.options || [])];
                                                                                    nextOptions[optIndex] = value;
                                                                                    return { ...current, options: nextOptions };
                                                                                });
                                                                            }}
                                                                        />
                                                                    </Grid>
                                                                    <Grid item xs={2}>
                                                                        <Button
                                                                            onClick={() => {
                                                                                updateTemplateAtIndex(index, (current) => ({
                                                                                    ...current,
                                                                                    options: (current.options || []).filter((_, optionIndex) => optionIndex !== optIndex),
                                                                                }));
                                                                            }}
                                                                            variant="contained"
                                                                            style={{
                                                                                color: "#fff",
                                                                                backgroundColor: "#d12c2c",
                                                                                marginTop: "10px",
                                                                                textTransform: 'capitalize',
                                                                            }}
                                                                        >
                                                                            Remove
                                                                        </Button>
                                                                    </Grid>
                                                                </Grid>
                                                            ))}
                                                            <Button
                                                                onClick={() => {
                                                                    updateTemplateAtIndex(index, (current) => ({
                                                                        ...current,
                                                                        options: [...(current.options || []), ''],
                                                                    }));
                                                                }}
                                                                variant="contained"
                                                                color="primary"
                                                                style={{ marginTop: "10px", textTransform: 'capitalize' }}
                                                            >
                                                                Add Option
                                                            </Button>
                                                        </Grid>
                                                    )}
                                                    <Grid item xs={2}>
                                                        <Button
                                                            onClick={() => removeTemplateField(index)}
                                                            variant="contained"
                                                            style={{
                                                                color: "#fff",
                                                                backgroundColor: "#d12c2c",
                                                                marginTop: "10px",
                                                                textTransform: 'capitalize',
                                                            }}
                                                        >
                                                            Delete
                                                        </Button>
                                                    </Grid>
                                                </Grid>
                                            ))}

                                            <Grid item xs={12} style={{ marginTop: "10px" }}>
                                                <Button onClick={addTemplateField} variant="contained" color="primary" className="common-action-button" style={{ textTransform: 'capitalize' }}>
                                                    Add Input Field
                                                </Button>
                                            </Grid>
                                            */}

                                            <Grid container className={classes.root} spacing={3}>
                                                <Grid item xs={4}>
                                                    <Button type="submit" className="btn-success" style={{ marginTop: "10px", float: 'left', marginBottom: "15px", textTransform: 'capitalize' }} variant="contained" color="primary">
                                                        Edit
                                                    </Button>
                                                    <Button type="button" className="btn-cancel" style={{ marginTop: "10px", float: 'left', marginBottom: "15px", textTransform: 'capitalize' }} onClick={(e) => { e.preventDefault(); props.history.push('/templates'); }}>
                                                        Cancel
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </form>
                                </div>
                            </Grid>
                        </Grid>
                    </div>
                }
            />
            <Footer />
        </div>
    );
};

export default Edittemplate;
